import template from './uploadAvatar.template.html';

/* @ngInject */

export default (
  $q,
  $state,
  $rootScope,
  $scope,
  $timeout,
  $mdDialog,
  $filter,
  webpage,
  cookies,
  eventService,
  uiService,
  authenticationService,
  organizationService,
  accountService,
  fieldService,
  OrganizationEnterprise,
  Field,
  FieldType,
  ACCOUNT,
  INSTANCE
) => {
  $scope.Model = {
    AUTH: authenticationService,
    isDev: $rootScope.isDev(),
    subPageTitle: '',
    availableFieldTypes: [],
    childState: {
      myAccount: false,
      myAccreditations: false,
      myPersonalization: false,
      myUpdatesAndReminders: false,
      lenderCommissions: false,
      groupsAndBranches: false,
      branding: false,
      features: false,
      professionalLicenses: false,
      organizationDetails: false,
      users: false,
      connect: false,
      marketing: false,
      diversification: false,
      clientPortal: false,
      partnerPortal: false,
      permissions: false,
      financialPositionBuffers: false,
      myOrganizations: false,
      billing: false,
      checklists: false,
      labels: false,
      tasks: false,
      notifications: false,
      marketingNotifications: false,
      documents: false,
      scripts: false,
      fields: false,
      crossSellOpportunities: false,
      workflows: false,
      workflowSettings: false,
      commissions: false,
      commissionLimits: false,
      lenders: false,
      access: false,
      integrations: false,
      api: false,
      importData: false,
      exportData: false
    },
    childStateIsArchive: false,
    childStateHasSelection: false,
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    isSuspended: authenticationService.isSuspended(),
    isOwner: authenticationService.isOwner(),
    isAdministrator: authenticationService.isAdministrator(),
    isReady: false
  };

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const clearChildState = () => {
    $scope.Model.childState.myAccount = false;
    $scope.Model.childState.myAccreditations = false;
    $scope.Model.childState.myPersonalization = false;
    $scope.Model.childState.myUpdatesAndReminders = false;
    $scope.Model.childState.lenderCommissions = false;
    $scope.Model.childState.groupsAndBranches = false;
    $scope.Model.childState.branding = false;
    $scope.Model.childState.features = false;
    $scope.Model.childState.professionalLicenses = false;
    $scope.Model.childState.myPasswordAndSecurity = false;
    $scope.Model.childState.organizationDetails = false;
    $scope.Model.childState.users = false;
    $scope.Model.childState.connect = false;
    $scope.Model.childState.marketing = false;
    $scope.Model.childState.diversification = false;
    $scope.Model.childState.clientPortal = false;
    $scope.Model.childState.partnerPortal = false;
    $scope.Model.childState.permissions = false;
    $scope.Model.childState.financialPositionBuffers = false;
    $scope.Model.childState.myOrganizations = false;
    $scope.Model.childState.billing = false;
    $scope.Model.childState.checklists = false;
    $scope.Model.childState.labels = false;
    $scope.Model.childState.tasks = false;
    $scope.Model.childState.notifications = false;
    $scope.Model.childState.marketingNotifications = false;
    $scope.Model.childState.documents = false;
    $scope.Model.childState.documentEditPdf = false;
    $scope.Model.childState.scripts = false;
    $scope.Model.childState.fields = false;
    $scope.Model.childState.crossSellOpportunities = false;
    $scope.Model.childState.workflows = false;
    $scope.Model.childState.workflowSettings = false;
    $scope.Model.childState.commissions = false;
    $scope.Model.childState.commissionLimits = false;
    $scope.Model.childState.lenders = false;
    $scope.Model.childState.access = false;
    $scope.Model.childState.integrations = false;
    $scope.Model.childState.api = false;
    $scope.Model.childState.importData = false;
    $scope.Model.childState.exportData = false;

    $scope.Model.childStateIsArchive = false;
    $scope.Model.childStateHasSelection = false;
  };

  const setChildState = (stateName) => {
    switch (stateName) {
      case 'settings.my-account':
        clearChildState();
        $scope.Model.subPageTitle = 'My account';
        $scope.Model.childState.myAccount = true;
        break;
      case 'settings.my-accreditations':
        clearChildState();
        $scope.Model.subPageTitle = 'My accreditations';
        $scope.Model.childState.myAccreditations = true;
        break;
      case 'settings.my-personalization':
        clearChildState();
        $scope.Model.subPageTitle = 'My personalization';
        $scope.Model.childState.myPersonalization = true;
        break;
      case 'settings.updates-and-reminders':
        clearChildState();
        $scope.Model.subPageTitle = 'My updates and reminders';
        $scope.Model.childState.myUpdatesAndReminders = true;
        break;
      case 'settings.password-and-security':
        clearChildState();
        $scope.Model.subPageTitle = 'My password and security';
        $scope.Model.childState.myPasswordAndSecurity = true;
        break;
      case 'settings.lender-commissions':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Lender commissions';
          $scope.Model.childState.lenderCommissions = true;
        }
        break;
      case 'settings.groups-and-branches':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Groups and branches';
          $scope.Model.childState.groupsAndBranches = true;
        }
        break;
      case 'settings.branding':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Branding';
          $scope.Model.childState.branding = true;
        }
        break;
      case 'settings.features':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Features';
          $scope.Model.childState.features = true;
        }
        break;
      case 'settings.professional-licenses':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Professional licenses';
          $scope.Model.childState.professionalLicenses = true;
        }
        break;
      case 'settings.organization':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Details';
          $scope.Model.childState.organizationDetails = true;
        }
        break;
      case 'settings.users':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Users';
          $scope.Model.childState.users = true;
        }
        break;
      case 'settings.connect':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Connect';
          $scope.Model.childState.connect = true;
        }
        break;
      case 'settings.marketing':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Marketing';
          $scope.Model.childState.marketing = true;
        }
        break;
      case 'settings.diversification':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Diversification';
          $scope.Model.childState.diversification = true;
        }
        break;
      case 'settings.client-portal':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Client portal';
          $scope.Model.childState.clientPortal = true;
        }
        break;
      case 'settings.partner-portal':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Partner portal';
          $scope.Model.childState.partnerPortal = true;
        }
        break;
      case 'settings.permissions':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Permissions';
          $scope.Model.childState.permissions = true;
        }
        break;
      case 'settings.financial-position-buffers':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Financial position buffers';
          $scope.Model.childState.financialPositionBuffers = true;
        }
        break;
      case 'settings.my-organizations':
        clearChildState();
        $scope.Model.subPageTitle = 'My organizations';
        $scope.Model.childState.myOrganizations = true;
        break;
      case 'settings.plan-and-billing':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = $rootScope.IsEnterprise
            ? 'Billing details'
            : 'Plan and billing details';
          $scope.Model.childState.billing = true;
        }
        break;
      case 'settings.checklists':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Required documents';
          $scope.Model.childState.checklists = true;
        }
        break;
      case 'settings.labels':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Labels';
          $scope.Model.childState.labels = true;
        }
        break;
      case 'settings.tasks':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Tasks';
          $scope.Model.childState.tasks = true;
        }
        break;
      case 'settings.notifications':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'External notifications';
          $scope.Model.childState.notifications = true;
        }
        break;
      case 'settings.marketing-notifications':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Marketing notifications';
          $scope.Model.childState.marketingNotifications = true;
        }
        break;
      case 'settings.documents':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Merge templates';
          $scope.Model.childState.documents = true;
        }
        break;
      case 'settings.documents-fill-pdf':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Document edit PDF';
          $scope.Model.childState.documentEditPdf = true;
        }
        break;
      case 'settings.scripts':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Call scripts';
          $scope.Model.childState.scripts = true;
        }
        break;
      case 'settings.fields':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Custom fields';
          $scope.Model.childState.fields = true;
          $scope.Model.availableFieldTypes = FieldType.available();
        }
        break;
      case 'settings.cross-sell-opportunities':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Cross Sell Opportunities';
          $scope.Model.childState.crossSellOpportunities = true;
        }
        break;
      case 'settings.workflows':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Workflows';
          $scope.Model.childState.workflows = true;
        }
        break;
      case 'settings.workflow':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Workflow settings';
          $scope.Model.childState.workflowSettings = true;
        }
        break;
      case 'settings.commission-groups':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Commission groups';
          $scope.Model.childState.commissions = true;
        }
        break;
      case 'settings.commission-limits':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Commission limits';
          $scope.Model.childState.commissionLimits = true;
        }
        break;
      case 'settings.lender-settings':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Lender settings';
          $scope.Model.childState.lenders = true;
        }
        break;
      case 'settings.access':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Access';
          $scope.Model.childState.access = true;
        }
        break;
      case 'settings.integrations':
        clearChildState();
        $scope.Model.subPageTitle = '3rd party applications';
        $scope.Model.childState.integrations = true;
        break;
      case 'settings.api':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'API';
          $scope.Model.childState.api = true;
        }
        break;
      case 'settings.import-data':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Import';
          $scope.Model.childState.importData = true;
        }
        break;
      case 'settings.export-data':
        clearChildState();
        if (!$scope.Model.isAdministrator) {
          $state.transitionTo('settings.my-account');
        } else {
          $scope.Model.subPageTitle = 'Export';
          $scope.Model.childState.exportData = true;
        }
        break;
      default:
        break;
    }
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  $q.all([
    $rootScope.CurrentAccount.isAdministrator
      ? organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id })
      : null
  ])
    .then((data) => {
      // Overwrite $rootScope values in case they've reverted to values within Token
      if ($rootScope.CurrentAccount.isAdministrator) {
        // eslint-disable-next-line no-param-reassign
        $rootScope.CurrentOrganization.enterprise = OrganizationEnterprise.build(
          data[0].enterprise
        );
      }
    })
    .then(() => {
      // Declare Model as Ready and start rendering the page
      webpage.pageTitle('Settings');
      setChildState($state.current.name);
      $scope.Model.isReady = true;
    });

  /*
   * Suspended Events
   * --------------------------------------------------------------------------------
   */
  eventService.onCredentialsChanged(() => {
    $scope.Model.isSuspended = false;
  });

  /*
   * Account Events
   * --------------------------------------------------------------------------------
   */
  $scope.accountAvatarUpload = ($event) => {
    $scope.$broadcast('accountAvatar', $event);
  };

  /*
   * My Organizations Events
   * --------------------------------------------------------------------------------
   */
  $scope.organizationDelete = () => {
    $scope.$broadcast('organizationDelete');
  };
  $scope.organizationAdd = ($event) => {
    $scope.$broadcast('organizationAdd', $event);
  };

  /*
   * Plan and Billing Events
   * --------------------------------------------------------------------------------
   */
  $scope.exportBillables = () => {
    $scope.$broadcast('exportBillables');
  };
  $scope.subscriptionChangePlan = () => {
    $scope.$broadcast('subscriptionChangePlan');
  };
  $scope.subscriptionChangePayment = ($event) => {
    $scope.$broadcast('subscriptionChangePayment', $event);
  };
  $scope.subscriptionCancel = ($event) => {
    $scope.$broadcast('subscriptionCancel', $event);
  };

  /*
   * Commission Events
   * --------------------------------------------------------------------------------
   */
  $scope.commissionDelete = () => {
    $scope.$broadcast('commissionDelete');
  };
  $scope.commissionDuplicate = () => {
    $scope.$broadcast('commissionDuplicate');
  };
  $scope.commissionActivate = () => {
    $scope.$broadcast('commissionActivate');
  };
  $scope.commissionArchive = () => {
    $scope.$broadcast('commissionArchive');
  };
  $scope.commissionAdd = ($event) => {
    $scope.$broadcast('commissionAdd', $event);
  };

  /*
   * Users Events
   * --------------------------------------------------------------------------------
   */
  $scope.groupsAndBranchesDelete = ($event) => {
    $scope.$broadcast('groupsAndBranchesDelete', $event);
  };
  $scope.groupsAndBranchesAdd = ($event) => {
    $scope.$broadcast('groupsAndBranchesAdd', $event);
  };

  /*
   * Users Events
   * --------------------------------------------------------------------------------
   */
  $scope.userDelete = () => {
    $scope.$broadcast('userDelete');
  };
  $scope.userAdd = ($event) => {
    $scope.$broadcast('userAdd', $event);
  };

  /*
   * Partners Events
   * --------------------------------------------------------------------------------
   */
  $scope.partnerDelete = () => {
    $scope.$broadcast('partnerDelete');
  };
  $scope.partnerAdd = ($event) => {
    $scope.$broadcast('partnerAdd', $event);
  };

  /*
   * Connect Events
   * --------------------------------------------------------------------------------
   */
  $scope.phoneRent = ($event) => {
    $scope.$broadcast('phoneRent', $event);
  };
  $scope.phoneUnrent = ($event) => {
    $scope.$broadcast('phoneUnrent', $event);
  };

  /*
   * Job Type Events
   * --------------------------------------------------------------------------------
   */
  $scope.jobTypeDelete = () => {
    $scope.$broadcast('jobTypeDelete');
  };
  $scope.jobTypeDuplicate = () => {
    $scope.$broadcast('jobTypeDuplicate');
  };
  $scope.jobTypeActivate = () => {
    $scope.$broadcast('jobTypeActivate');
  };
  $scope.jobTypeArchive = () => {
    $scope.$broadcast('jobTypeArchive');
  };
  $scope.jobTypeAdd = ($event) => {
    $scope.$broadcast('jobTypeAdd', $event);
  };

  /*
   * Message Events
   * --------------------------------------------------------------------------------
   */
  $scope.messageDelete = () => {
    $scope.$broadcast('messageDelete');
  };
  $scope.messageDuplicate = () => {
    $scope.$broadcast('messageDuplicate');
  };
  $scope.messageActivate = () => {
    $scope.$broadcast('messageActivate');
  };
  $scope.messageArchive = () => {
    $scope.$broadcast('messageArchive');
  };
  $scope.messageAdd = ($event) => {
    $scope.$broadcast('messageAdd', $event);
  };

  /*
   * Document Events
   * --------------------------------------------------------------------------------
   */
  $scope.documentDelete = () => {
    $scope.$broadcast('documentDelete');
  };
  $scope.documentRename = () => {
    $scope.$broadcast('documentRename');
  };
  $scope.documentDuplicate = () => {
    $scope.$broadcast('documentDuplicate');
  };
  $scope.documentActivate = () => {
    $scope.$broadcast('documentActivate');
  };
  $scope.documentArchive = () => {
    $scope.$broadcast('documentArchive');
  };
  $scope.documentMergeFields = ($event) => {
    $scope.$broadcast('documentMergeFields', $event);
  };
  $scope.documentAdd = ($event) => {
    $scope.$broadcast('documentAdd', $event);
  };

  /*
   * Script Events
   * --------------------------------------------------------------------------------
   */
  $scope.scriptDelete = () => {
    $scope.$broadcast('scriptDelete');
  };
  $scope.scriptDuplicate = () => {
    $scope.$broadcast('scriptDuplicate');
  };
  $scope.scriptActivate = () => {
    $scope.$broadcast('scriptActivate');
  };
  $scope.scriptArchive = () => {
    $scope.$broadcast('scriptArchive');
  };
  $scope.scriptAdd = ($event) => {
    $scope.$broadcast('scriptAdd', $event);
  };

  /*
   * Checklist Events
   * --------------------------------------------------------------------------------
   */
  $scope.checklistDelete = () => {
    $scope.$broadcast('checklistDelete');
  };
  $scope.checklistDuplicate = () => {
    $scope.$broadcast('checklistDuplicate');
  };
  $scope.checklistActivate = () => {
    $scope.$broadcast('checklistActivate');
  };
  $scope.checklistArchive = () => {
    $scope.$broadcast('checklistArchive');
  };
  $scope.checklistAdd = ($event) => {
    $scope.$broadcast('checklistAdd', $event);
  };

  /*
   * Label Events
   * --------------------------------------------------------------------------------
   */
  $scope.labelDelete = () => {
    $scope.$broadcast('labelDelete');
  };
  $scope.labelDuplicate = () => {
    $scope.$broadcast('labelDuplicate');
  };
  $scope.labelActivate = () => {
    $scope.$broadcast('labelActivate');
  };
  $scope.labelArchive = () => {
    $scope.$broadcast('labelArchive');
  };
  $scope.labelAdd = ($event) => {
    $scope.$broadcast('labelAdd', $event);
  };

  /*
   * Field Events
   * --------------------------------------------------------------------------------
   */
  $scope.fieldDelete = () => {
    $scope.$broadcast('fieldDelete');
  };
  $scope.fieldDuplicate = () => {
    $scope.$broadcast('fieldDuplicate');
  };
  $scope.fieldActivate = () => {
    $scope.$broadcast('fieldActivate');
  };
  $scope.fieldArchive = () => {
    $scope.$broadcast('fieldArchive');
  };
  $scope.fieldAdd = ($event, fieldType) => {
    $scope.$broadcast('fieldAdd', $event, fieldType);
  };

  /*
   * Access Events
   * --------------------------------------------------------------------------------
   */
  $scope.accessAddOutbound = () => {
    $scope.$broadcast('accessAddOutbound');
  };
  $scope.accessAddInbound = () => {
    $scope.$broadcast('accessAddInbound');
  };
  $scope.accessAddWebForm = () => {
    $scope.$broadcast('accessAddWebForm');
  };
  $scope.accessAddLoanq = () => {
    $scope.$broadcast('accessAddLoanq');
  };

  /*
   * Workflow Events
   * --------------------------------------------------------------------------------
   */
  $scope.workflowDelete = () => {
    $scope.$broadcast('workflowDelete');
  };
  $scope.workflowDuplicate = () => {
    $scope.$broadcast('workflowDuplicate');
  };
  $scope.workflowActivate = () => {
    $scope.$broadcast('workflowActivate');
  };
  $scope.workflowArchive = () => {
    $scope.$broadcast('workflowArchive');
  };

  /*
   * Workflow Settings Events
   * --------------------------------------------------------------------------------
   */
  $scope.workflowSettingsAddStage = () => {
    $scope.$broadcast('workflowSettingsAddStage');
  };

  /*
   * Export Events
   * --------------------------------------------------------------------------------
   */
  $scope.exportData = () => {
    $scope.$broadcast('exportData');
  };

  /*
   * Events Watcher
   * --------------------------------------------------------------------------------
   */
  $rootScope.$on('$stateChangeStart', ($event, toState) => {
    setChildState(toState.name);
  });

  /*
   * UI Methods
   * --------------------------------------------------------------------------------
   */
  $scope.uploadAvatar = ($event) => {
    function uploadAvatarController() {
      this.url = ACCOUNT.API.UPLOAD;
      this.allowMultiple = ACCOUNT.LIMITS.MULTIPLE;
      this.allowedMimeTypes = ACCOUNT.LIMITS.ALLOWED_MIME;
      this.allowedExtensions = ACCOUNT.LIMITS.ALLOWED_EXTENSIONS;
      this.minimumWidth = ACCOUNT.LIMITS.MIN_WIDTH;
      this.minimumHeight = ACCOUNT.LIMITS.MIN_HEIGHT;
      this.aspectRatio = ACCOUNT.LIMITS.ASPECT_RATIO;
      this.uploadFinished = (logo) => {
        $mdDialog.hide(logo);
      };
      this.confirm = () => {
        this.startUpload = true;
      };
      this.cancel = () => {
        $mdDialog.cancel();
      };
    }

    $mdDialog
      .show({
        targetEvent: $event,
        locals: {},
        template,
        controllerAs: '$ctrl',
        controller: uploadAvatarController
      })
      .then(() => {
        $timeout(() => {
          if (
            $rootScope.CurrentAccount.getAvatar() !==
            `${INSTANCE.cdn}/avatars/${$rootScope.CurrentAccount.id}.png`
          ) {
            // eslint-disable-next-line no-param-reassign
            $rootScope.CurrentAccount.user.avatar = `${INSTANCE.cdn}/avatars/${$rootScope.CurrentAccount.id}.png`;
          }
          accountService
            .updateAccount({
              id: $rootScope.CurrentAccount.id,
              user: $rootScope.CurrentAccount.user
            })
            .then((result) => {
              if (result.status) {
                uiService.toast({
                  text: {
                    p1: 'Avatar',
                    p2: 'changed',
                    p3: 'successfully'
                  }
                });
                $timeout(() => {
                  eventService.accountAvatarUploaded();
                }, 250);
              }
            });
        });
      });
  };

  /*
   * Helper Methods
   * --------------------------------------------------------------------------------
   */
  $scope.isHelpDesk = () =>
    String($rootScope.CurrentAccount.getEmail()).trim() === 'helpdesk@salestrekker.com';

  $scope.isAccountManagementAllowed = () => {
    return (
      $rootScope.CurrentOrganization.isRoot() ||
      (!$rootScope.CurrentOrganization.isRoot() && authenticationService.isManager())
    );
  };

  $scope.isOwner = () => {
    return authenticationService.isOwner();
  };

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), { path: '/' });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.setCaretClass = (isView) => {
    return `${isView ? 'down' : 'up'} ${
      $scope.Model.isSidebarMinimized || !$rootScope.IsMedia('gt-sm') ? 'hide' : ''
    }`;
  };

  $scope.getFieldTypeIcon = (fieldType) => fieldService.getFieldTypeIcon(fieldType);
};
